<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-11 col-sm-9 col-md-7 col-lg-6 col-xl-5 text-center p-0 mt-3 mb-2">
        <div class="card px-0 pt-4 pb-0 mt-3 mb-3">
          <h2 id="heading">Sign Up Your User Account</h2>
          <p>Fill all form field to go to next step</p>
          <form id="msform">

            <!-- progressbar -->
            <ul id="progressbar">
              <li :class="accountActive" id="account"><strong>Account</strong></li>
              <li :class="personalActive" id="personal"><strong>Personal</strong></li>
              <li :class="companyActive" id="company"><strong>Company</strong></li>
              <li :class="finishActive" id="confirm"><strong>Finish</strong></li>
            </ul>
            <div class="progress">
              <CProgress
                :value="progressValue"
                color = "#0d6efd"
                min="0"
                max="100"
                animated
                style="width:100%;"
                class="progress_bar"
              />
            </div> <br>

<!--            changed to vue-->
            <fieldset>
              <div class="form-card">
                <div class="row">
                  <div class="col-7">
                    <h2 class="fs-title">{{ stepName }}:</h2>
                  </div>
                  <div class="col-5">
                    <h2 class="steps">Step {{ step }} - 4</h2>
                  </div>
                </div>

<!--                step 1-->
                <div v-if="step === 1">
                  <CInput
                      v-model="accountInformation.email"
                      class="my-3"
                      type="email"
                      label="Email"
                      placeholder="example@company_name.com"
                  />
                  <CInput
                      v-model="accountInformation.username"
                      class="my-3"
                      type="text"
                      label="Username"
                      placeholder="Username"
                  />
                  <CInput
                      v-model="accountInformation.password"
                      class="my-3"
                      type="password"
                      label="Password"
                      placeholder="Password"
                  />
                  <CInput
                      v-model="confirmedPassword"
                      class="my-3"
                      type="password"
                      label="Confirm password"
                      placeholder="Confirm password"
                  />
                </div>

<!--                step 2-->
                <div v-if="step === 2">
                  <CInput
                      v-model="personalInformation.firstName"
                      class="my-3"
                      type="text"
                      label="First Name"
                      placeholder="First Name"
                  />
                  <CInput
                      v-model="personalInformation.lastName"
                      class="my-3"
                      type="text"
                      label="Last Name"
                      placeholder="Last Name"
                  />
                  <CInput
                      v-model="personalInformation.phoneNumber"
                      class="my-3"
                      type="number"
                      label="Contact No."
                      placeholder="Contact No."
                  />
                </div>

<!--                    step 3-->
                <div v-if="step === 3">
                  <CInput
                      v-model="companyInformation.name"
                      class="my-3"
                      label="Company Name"
                      placeholder="Company name"
                  />
                  <CInput
                      v-model="companyInformation.address"
                      class="my-3"
                      label="Address"
                      placeholder="Address"
                  />
                  <CRow class="justify-content-between">
                    <CCol md="6">
                      <CInput
                          v-model="companyInformation.city"
                          label="City"
                          placeholder="City"
                      />
                    </CCol>
                    <CCol md="3">
                      <CInput
                          v-model="companyInformation.state"
                          label="State"
                          placeholder="State"
                      />
                    </CCol>
                    <CCol md="2">
                      <CInput
                          v-model="companyInformation.zip"
                          label="Zip"
                          placeholder="Zip code"
                      />
                    </CCol>
                  </CRow>
                  <CInput
                      v-model="companyInformation.country"
                      class="my-3"
                      label="Country"
                      placeholder="Country"
                  />
                  <CTextarea
                      v-model="companyInformation.description"
                      class="my-3"
                      label="Description"
                      placeholder="Summary"
                      rows="5"
                  />
                </div>

<!--                step 4-->
                <div v-if="step === 4">
                  <h2 class="purple-text text-center"><strong>SUCCESS !</strong></h2> <br>
                  <div class="row justify-content-center">
                    <div class="col-3">
                      <img :src="finishPicture" class="fit-image">
                    </div>
                  </div> <br><br>
                  <div class="row justify-content-center">
                    <div class="col-7 text-center">
                      <h5 class="purple-text text-center">You Have Successfully Signed Up</h5>
                    </div>
                  </div>
                </div>

<!--                form button-->
                <div v-show="step < 4" class="card_footer">
                  <button
                      v-show="step > 1"
                      class="mx-3 btn btn-outline-secondary"
                      type="button"
                      @click="previous"
                      style="width: 85px; height: 40px">Previous
                  </button>
                  <button
                      class="mx-3 btn btn-outline-primary"
                      type="button"
                      @click="next()"
                      style="width: 70px; height: 40px">{{ (step === 3) ? 'Submit' : 'Next' }}
                  </button>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Signup",
  data () {
    return {
      stepName: 'Account Information',
      step: 1,
      accountActive: 'active',
      personalActive: '',
      companyActive: '',
      finishActive:'',
      progressValue: 25,
      accountInformation: {
        email:'',
        username: '',
        password: ''
      },
      personalInformation: {
        firstName: '',
        lastName: '',
        phoneNumber: ''
      },
      companyInformation: {
        name: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        description: ''
      },
      confirmedPassword: '',
      finishPicture: require('@/assets/images/success.png')
    }
  },
  methods: {
    next() {
      let self = this;

      if (self.step === 1) {
        self.stepName = 'Personal Information'
        self.personalActive = 'active'
        self.progressValue = 50
      } else if (self.step === 2) {
        self.stepName = 'Company Information'
        self.companyActive = 'active'
        self.progressValue = 75
      } else if (self.step === 3) {
        self.stepName = 'Finish'
        self.finishActive = 'active'
        self.progressValue = 100
        self.submit()
      }

      self.step = self.step + 1
    },
    previous() {
      let self = this;

      if (self.step === 1) {
        self.stepName = ''
      } else if (self.step === 2) {
        self.stepName = 'Account Information'
        self.personalActive = ''
        self.progressValue = 25
      } else if (self.step === 3) {
        self.stepName = 'Personal Information'
        self.companyActive = ''
        self.progressValue = 50
      } else if (self.step === 4) {
        self.stepName = 'Finish'
        self.finishActive = ''
      }

      self.step = self.step - 1
    },
    submit() {
      let self = this
      console.log('account information', self.accountInformation)
      console.log('personal information', self.personalInformation)
      console.log('company information', self.companyInformation)
    }
  }
}
</script>

<style scoped>
@import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.0.3/css/font-awesome.css";

.card_footer {
  justify-content: right;
  display: flex;
}

* {
  margin: 0;
  padding: 0
}

html {
  height: 100%
}

p {
  color: grey
}

#heading {
  text-transform: uppercase;
  color: #0d6efd;
  font-weight: normal
}

#msform {
  text-align: center;
  position: relative;
  margin-top: 20px
}

#msform fieldset {
  background: white;
  border: 0 none;
  border-radius: 0.5rem;
  box-sizing: border-box;
  width: 100%;
  margin: 0;
  padding-bottom: 20px;
  position: relative
}

.form-card {
  text-align: left
}

#msform fieldset:not(:first-of-type) {
  display: none
}

#msform input,
#msform textarea {
  padding: 8px 15px 8px 15px;
  border: 1px solid #ccc;
  border-radius: 0px;
  margin-bottom: 25px;
  margin-top: 2px;
  width: 100%;
  box-sizing: border-box;
  font-family: montserrat;
  color: #2C3E50;
  background-color: #ECEFF1;
  font-size: 16px;
  letter-spacing: 1px
}

#msform input:focus,
#msform textarea:focus {
  -moz-box-shadow: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  border: 1px solid #0d6efd;
  outline-width: 0
}

#msform .action-button {
  width: 100px;
  background: #0d6efd;
  font-weight: bold;
  color: white;
  border: 0 none;
  border-radius: 0px;
  cursor: pointer;
  padding: 10px 5px;
  margin: 10px 0px 10px 5px;
  float: right
}

#msform .action-button:hover,
#msform .action-button:focus {
  background-color: #0d6efd
}

#msform .action-button-previous {
  width: 100px;
  background: #616161;
  font-weight: bold;
  color: white;
  border: 0 none;
  border-radius: 0px;
  cursor: pointer;
  padding: 10px 5px;
  margin: 10px 5px 10px 0px;
  float: right
}

#msform .action-button-previous:hover,
#msform .action-button-previous:focus {
  background-color: #000000
}

.card {
  z-index: 0;
  border: none;
  position: relative
}

.fs-title {
  font-size: 25px;
  color: #0d6efd;
  margin-bottom: 15px;
  font-weight: normal;
  text-align: left
}

.purple-text {
  color: #0d6efd;
  font-weight: normal
}

.steps {
  font-size: 25px;
  color: gray;
  margin-bottom: 10px;
  font-weight: normal;
  text-align: right
}

.fieldlabels {
  color: gray;
  text-align: left
}

#progressbar {
  margin-bottom: 30px;
  overflow: hidden;
  color: lightgrey
}

#progressbar .active {
  color: #0d6efd
}

#progressbar li {
  list-style-type: none;
  font-size: 15px;
  width: 25%;
  float: left;
  position: relative;
  font-weight: 400
}

#progressbar #account:before {
  font-family: FontAwesome;
  content: "\f13e"
}

#progressbar #personal:before {
  font-family: FontAwesome;
  content: "\f007"
}

#progressbar #company:before {
  font-family: FontAwesome;
  content: "\F0F7"
}

#progressbar #confirm:before {
  font-family: FontAwesome;
  content: "\f00c"
}

#progressbar li:before {
  width: 50px;
  height: 50px;
  line-height: 45px;
  display: block;
  font-size: 20px;
  color: #ffffff;
  background: lightgray;
  border-radius: 50%;
  margin: 0 auto 10px auto;
  padding: 2px
}

#progressbar li:after {
  content: '';
  width: 100%;
  height: 2px;
  background: lightgray;
  position: absolute;
  left: 0;
  top: 25px;
  z-index: -1
}

#progressbar li.active:before,
#progressbar li.active:after {
  background: #0d6efd
}

.progress {
  height: 20px
}

.progress-bar {
  background-color: #0d6efd
}

.fit-image {
  width: 100%;
  object-fit: cover
}
</style>
